module.exports = __webpack_public_path__ + "img/buildings.6a093b2d.png";